import API from '../../searchiAPI';
const ENTITY = 'search';

const getSessionParams = (branchOfficeId = null) => {
    return {
        branch_ids: branchOfficeId || '',
        role_type: 'owner',
        has_limited_contacts: false,
        statuses: 'active,archived',
    };
};

export const fetchContacts = ({
    page = 1,
    page_size = 25,
    q = '',
    branchOfficeId = null,
}) =>
    API.get(`/api/v1/${ENTITY}/contacts`, {
        params: { q, page, page_size, ...getSessionParams(branchOfficeId) },
    });
export const fetchProjects = ({
    page = 1,
    page_size = 25,
    q = '',
    branchOfficeId = null,
}) =>
    API.get(`/api/v1/${ENTITY}/projects`, {
        params: { q, page, page_size, ...getSessionParams(branchOfficeId) },
    });
export const fetchProposals = ({
    page = 1,
    page_size = 25,
    q = '',
    branchOfficeId = null,
}) =>
    API.get(`/api/v1/${ENTITY}/proposals`, {
        params: { q, page, page_size, ...getSessionParams(branchOfficeId) },
    });
